export interface RxUserData {
  firstName: string;
  lastName: string;
  email?: string;
  countryArea: string;
  birthDate?: Date | string;
  gender?: string;
  newsAndOffers?: boolean;
}

export class StorageManager {
  private static readonly RX_USER_DATA_KEY = "rxUserData";
  private static readonly NMI_SCRIPT_CONFIG_KEY = "nmiScriptConfig";

  static getRxUserData(): RxUserData | null {
    try {
      const data = localStorage.getItem(this.RX_USER_DATA_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error("Error reading rxUserData from localStorage");
      return null;
    }
  }

  static setRxUserData(data: RxUserData): void {
    try {
      localStorage.setItem(this.RX_USER_DATA_KEY, JSON.stringify(data));
    } catch (error) {
      console.error("Error writing rxUserData to localStorage");
    }
  }

  static getNmiScriptConfig(): { apiKey: string; environment: string } | null {
    try {
      const data = localStorage.getItem(this.NMI_SCRIPT_CONFIG_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error("Error reading NMI script config from localStorage");
      return null;
    }
  }

  static setNmiScriptConfig(config: { apiKey: string; environment: string }): void {
    try {
      localStorage.setItem(this.NMI_SCRIPT_CONFIG_KEY, JSON.stringify(config));
    } catch (error) {
      console.error("Error writing NMI script config to localStorage");
    }
  }

  static clearNmiScriptConfig(): void {
    try {
      localStorage.removeItem(this.NMI_SCRIPT_CONFIG_KEY);
    } catch (error) {
      console.error("Error clearing NMI script config from localStorage");
    }
  }

  static hasValidEmail(): boolean {
    const userData = this.getRxUserData();
    return !!(userData?.email && userData.email.length > 0);
  }
}
